import React from "react";

const ChartSelector = ({ chartTypes, selectedChartType, onSelectChart }) => {
  return (
    <div>
      <select
        value={selectedChartType}
        onChange={(e) => onSelectChart(e.target.value)}
        className="ms-3 mt-2 block btn w-48 p-3 rounded-md"
      >
        {chartTypes.map((type) => (
          <option key={type.value} value={type.value}>
            {type.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ChartSelector;
